import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type {
    ReviewerPaymentItem,
    GetReadyForReviewerPaymentPayload,
    BankAccountDetail,
    CreateUpdateReviewerPaymentPayload,
    ReviewerPaymentRecord,
} from './types';

export const reviewerPaymentService = {
    getReadyForReviewerPayment: async (
        payload: GetReadyForReviewerPaymentPayload
    ): Promise<ApiResponse<PaginatedResponse<ReviewerPaymentItem>>> => {
        const response = await apiClient.post('/ReviewerPayments/GetReadyForReviewerPayment', {
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            sortBy: payload.sortBy || '',
            sortDescending: payload.sortDescending ?? true,
            search: payload.search || '',
        });
        return response.data;
    },

    getBankAccountDetailByUserId: async (
        userId: string
    ): Promise<ApiResponse<BankAccountDetail>> => {
        const response = await apiClient.get(
            `/BankAccountDetails/GetBankAccountDetailByUserId?userId=${userId}`
        );
        return response.data;
    },

    createUpdateReviewerPayment: async (
        payload: CreateUpdateReviewerPaymentPayload
    ): Promise<ApiResponse<ReviewerPaymentRecord>> => {
        const response = await apiClient.post('/ReviewerPayments/CreateUpdateReviewerPayment', payload);
        return response.data;
    },

    getReviewerPaymentByReviewAssignmentId: async (
        reviewAssignmentId: string
    ): Promise<ApiResponse<ReviewerPaymentRecord>> => {
        const response = await apiClient.get(
            `/ReviewerPayments/GetReviewerPaymentByReviewAssignmentId?reviewAssignmentId=${reviewAssignmentId}`
        );
        return response.data;
    },

    deleteReviewerPayment: async (id: string): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/ReviewerPayments/DeletePaymentRecord?Id=${id}`);
        return response.data;
    },
};
